import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CurrencyMaskModule, CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from 'ng2-currency-mask';
import { AngularMaterialModule } from '@shared/modules/angular-material.module';
import { MatChipsModule } from '@angular/material/chips';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM/YYYY',
  },
};

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

import { declarations } from '@shared/declarations.organizer';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        AngularMaterialModule,
        ReactiveFormsModule,
        FormsModule,
        CurrencyMaskModule,
        MatChipsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        ...declarations
    ],
    exports: [
        ...declarations,
        CommonModule,
        RouterModule,
        TranslateModule,
        AngularMaterialModule,
        ReactiveFormsModule,
        FormsModule,
        CurrencyMaskModule,
        MatChipsModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    providers: [
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'pt-br',
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        provideNgxMask(),
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        DatePipe,
    ],
})
export class SharedModule {}
